module.exports = __webpack_public_path__ + "img/w7-b1.fb07bac7.jpg";